/**
 * The Resizable contract.
 *
 * Implemented by objects that can be resized.
 *
 * @interface
 */

export class Resizable {

	/**
	 * Sets the size of this object.
	 *
	 * @param {Number} width - The new width.
	 * @param {Number} height - The new height.
	 */

	setSize(width, height) {}

}



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/postprocessing/src/core/Resizable.js
// module id = 178
// module chunks = 0